<template>
    <div class="chartRow">
        <div class="chartCol">
            <div id="pieLeftChart" :style="{width: '96%', height: '360px'}"></div>
        </div>
        <div class="chartCol">
            <div id="pieRightChart" :style="{width: '96%', height: '360px'}"></div>
        </div>
    </div>
</template>

<script>
import './westeros.js'
export default {
    data(){
        return{
           
        }
    },
    mounted(){
        this.pieLeftChart()
        this.pieRightChart()
    },
    methods:{
        pieLeftChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('pieLeftChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '目标管理状态',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                
                legend: {
                    left: 'left',
                    top:'8%'
                },
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '50%'],
                        radius: ['78%', '78.2%'], // 数组的第一项是内半径、第二项是外半径
                        top:'15%',
                        itemStyle: {
                            color: '#CED5E1',
                        },
                        label: {
                            show: false,
                        },
                        data: [0],
                    },
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '70%',
                        top:'15%',
                        data: [
                            { value: 1048, name: '未提交' },
                            { value: 735, name: '计划中' },
                            { value: 580, name: '已完成' },
                        ],
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 20,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
        pieRightChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('pieRightChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '年度评估状态',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                
                legend: {
                    left: 'left',
                    top:'8%'
                },
                series: [
                    {
                        type: 'pie',
                        center: ['50%', '50%'],
                        radius: ['78%', '78.2%'], // 数组的第一项是内半径、第二项是外半径
                        top:'15%',
                        itemStyle: {
                            color: '#CED5E1',
                        },
                        label: {
                            show: false,
                        },
                        data: [0],
                    },
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: '70%',
                        top:'15%',
                        data: [
                            { value: 200, name: '未提交' },
                            { value: 300, name: '考核中' },
                            { value: 760, name: '已考核' },
                        ],
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 20,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    }
}
</script>

<style scoped>
.ivu-input-prefix i, .ivu-input-suffix i {
    line-height: 28px !important;
}
.chartRow {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.chartCol {
    width: 50%;
    padding: 20px;
    box-sizing: border-box;
    border:1px solid #dcdee2
}
.chartCol:nth-child(odd) {
    border-right:0px solid #dcdee2
}
.chartCol:nth-child(1) {
    border-bottom:0px solid #dcdee2
}
.chartCol:nth-child(2) {
    border-bottom:0px solid #dcdee2
}
</style>


// WEBPACK FOOTER //
// src/components/bipage/components/PieChart.vue